//  --PLATFORM ENVS
//  local
//  production
export const APP_ENV = 'production';
//  --PLATFORM ENVS
//  landing
//  application
export const PLATFORM_ENV = 'application';
export const CAPTCHA_COST = 0.22;
export const DASHBOARD_URL = 'https://app.explorant.space';
export const PAID_DASHBOARD_URLS = [
  // 'http://888818881.xyz',
  // 'http://999919991.xyz',
  // 'http://999929991.xyz',
  'http://515e1317-2df9-4ceb-b8c4-b60b2633359f.buzz',
  'http://808be016-4b51-47a0-9df3-552f1b3448af.buzz'
  // 'http://8c3de257-d7ef-4309-8dcb-1ca52825dfcc.buzz',
  // 'http://9bac6031-c824-43dd-8b69-566fe37fa719.buzz',
  // 'http://fe1964a2-5c8d-444a-8174-7c4f9a221410.buzz',
];
